import { cn } from "../../utils/cn";
import { MediaContent } from "./MediaContent";

interface PreviewCellProps {
  previewURL: string;

  depthURL?: string;

  size?: "default" | "large";

  sizeType?: "watchface" | "widget";
}

export function WatchFacePreview(props: PreviewCellProps) {
  const {
    previewURL,
    depthURL,
    size = "default",
    sizeType = "watchface",
  } = props;

  return (
    <div
      className={cn(
        "relative bg-white overflow-hidden border-2 border-gray-200 shadow-sm",
        sizeType === "widget"
          ? "aspect-[2/1] w-[200px]!"
          : "aspect-[26/31] w-[100px]",
        size === "default" ? "w-[100px]" : "w-[200px]"
      )}
      style={{ borderRadius: sizeType === "widget" ? "5px" : "23.6% / 19.8%" }}
    >
      {previewURL && <MediaContent src={previewURL} />}
      {depthURL && <MediaContent src={depthURL} />}
    </div>
  );
}
